export default "__VITE_ASSET__D19qOJgn__";